import React, { useState, useEffect } from 'react';
import { useNavigate, Link, Outlet, useLocation } from 'react-router-dom';
import { Package, Grid3x3, LogOut, Home, ShoppingBag, Settings, Lock, FileText, PenSquare, Mail, Image as ImageIcon, Share2, CheckCircle2, TrendingUp, Star } from 'lucide-react';
import { Button } from '../../components/ui/button';
import Logo from '../../components/Logo';
import adminApi from '../../lib/adminApi';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [adminUser, setAdminUser] = useState('');

  useEffect(() => {
    const user = localStorage.getItem('adminUser');
    if (!user) {
      navigate('/admin/login');
    } else {
      setAdminUser(user);
    }
  }, [navigate]);

  const handleLogout = async () => {
    try { await adminApi.post('/api/admin/logout'); } catch (e) { /* logout best-effort */ }
    localStorage.removeItem('adminUser');
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', icon: Home, label: 'Tableau de bord' },
    { path: '/admin/products', icon: Package, label: 'Produits' },
    { path: '/admin/collections', icon: Grid3x3, label: 'Collections' },
    { path: '/admin/orders', icon: ShoppingBag, label: 'Commandes' },
    { path: '/admin/quotes', icon: FileText, label: 'Devis' },
    { path: '/admin/audience', icon: TrendingUp, label: 'Audience' },
    { path: '/admin/blog', icon: PenSquare, label: 'Blog' },
    { path: '/admin/reviews', icon: Star, label: 'Avis clients' },
    { path: '/admin/media', icon: ImageIcon, label: 'Galerie' },
    { path: '/admin/media/validation', icon: CheckCircle2, label: 'Valider les médias' },
    { path: '/admin/social', icon: Share2, label: 'Réseaux sociaux' },
    { path: '/admin/newsletter', icon: Mail, label: 'Newsletter' },
    { path: '/admin/payment-settings', icon: Settings, label: 'Paiements' },
    { path: '/admin/security', icon: Lock, label: 'Sécurité' }
  ];

  return (
    <div className="min-h-screen bg-black">
      {/* Top Bar */}
      <div className="bg-gray-900 border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <Logo />
              <span className="text-gray-400 text-sm">| Administration</span>
            </div>
            
            <div className="flex items-center space-x-4">
              <span className="text-gray-400 text-sm">Bonjour, {adminUser}</span>
              <Button
                onClick={handleLogout}
                variant="ghost"
                size="sm"
                className="text-gray-400 hover:text-white"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Déconnexion
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 bg-gray-900 min-h-[calc(100vh-4rem)] border-r border-gray-800">
          <nav className="p-4 space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-orange-600 text-white'
                      : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>

          <div className="p-4 border-t border-gray-800 mt-8">
            <Link to="/" className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-400 hover:bg-gray-800 hover:text-white transition-colors">
              <Home className="w-5 h-5" />
              <span>Retour au site</span>
            </Link>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
